module.exports = __webpack_public_path__ + "/build/web/images/hero@2x.f004437dc7bb1b0e7a282ea17048fe91.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero@2x.jpg
// module id = 158
// module chunks = 13